import type { ReactNode } from "react";
import { useFeatureFlag } from "@/hooks/use-feature-flag";

/** Utstyrssidene vises bare når feature_equipment er på for rollen (VIB-2917). */
export function EquipmentFlagGate({ children }: { children: ReactNode }) {
  const enabled = useFeatureFlag("feature_equipment");
  if (!enabled) {
    return (
      <div className="page-container animate-fade-in">
        <h1 className="page-title">Utstyr</h1>
        <p className="text-muted-foreground">Ikke tilgjengelig ennå.</p>
      </div>
    );
  }
  return <>{children}</>;
}
